import { Injectable } from '@angular/core';
import { RoutesV3Service } from '@core/services/entities-services/routes-v3.service';
@Injectable({
  providedIn: 'root',
})
export class IntervalService {
  private intervalId: number | null = null;
  constructor(private _routesService: RoutesV3Service) {
  }
  public startInterval(): void {
    if (this.intervalId === null) {
      this.intervalId = window.setInterval(() => {
        this._routesService.loadElements(false);
        this._routesService.loadRoutesByLocation(false);
      }, 10 * 1000);
    }
  }
  public stopInterval(): void {
    if (this.intervalId !== null) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }
}
